import Typography from "@material-ui/core/Typography";
import {theme} from "../../../../../../../../../../shared/theme";

const ActivationRequestContent = () => {
    return (
        <Typography variant="body2" style={{color: theme.palette.grey[600]}}>
            La richiesta è stata presa in carico, verrà gestita entro le tempistiche previste
        </Typography>
    )
}

export default ActivationRequestContent;